import { observer } from 'mobx-react-lite'
import { TextToSpeech } from 'widgets/TextToSpeech/ui/TextToSpeech'
import { TextToSpeechModalActions } from 'widgets/TextToSpeech/ui/TextToSpeechModalActions/TextToSpeechModalActions'
import { type TextToSpeechWidgetStore } from 'widgets/TextToSpeech/store/textToSpeechWidgetStore'
import styles from './styles.module.scss'

type ITextToSpeechModalContentProps = {
  store: TextToSpeechWidgetStore
  onClose: () => void
}

export const TextToSpeechModalContent = observer(
  ({ store, onClose }: ITextToSpeechModalContentProps) => (
    <>
      <div className={styles.content}>
        <TextToSpeech store={store} variant={'modal'} />
      </div>
      <div className={styles.footer}>
        <TextToSpeechModalActions store={store} onClose={onClose} />
      </div>
    </>
  )
)
